export const firebaseConfig = {
  apiKey: "AIzaSyCIL6qvHfVrmNZssJ0X1LAdu9dLRSjS5qE",
  authDomain: "seguridad-sl-30669.firebaseapp.com",
  databaseURL: "https://seguridad-sl-30669.firebaseio.com",
  projectId: "seguridad-sl-30669",
  storageBucket: "seguridad-sl-30669.appspot.com",
  messagingSenderId: "780801507324",
  appId: "1:780801507324:web:978bf3f4b1742cca653c79",
  measurementId: "G-QM7SMZLSTW"
};
